module.exports = __webpack_public_path__ + "img/goal-eight-br.557813e0.png";